import { Play } from "lucide-react";

const VIDEO_ID = "WWSFEstXNUQ";
const VIDEO_URL = `https://www.youtube.com/embed/${VIDEO_ID}?rel=0&modestbranding=1`;

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 bg-[#F3F1E8]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-[#7a6f55] font-medium">
              <Play size={14} className="text-[#79804D]" strokeWidth={2} />
              Video del fraccionamiento
            </span>
            <h2 className="font-heading mt-4 text-4xl sm:text-5xl font-light tracking-tight text-[#2D2920] leading-[1.05]">
              Conoce el <em className="italic font-extralight text-[#3E482A]">desarrollo</em>.
            </h2>
          </div>
          <p className="md:max-w-md text-[#5a5340] font-light leading-relaxed">
            Un recorrido por Real San José: nuestras calles, lotes disponibles y
            el entorno natural que rodea el desarrollo.
          </p>
        </div>

        <div
          data-testid="video-wrapper"
          className="relative w-full overflow-hidden bg-[#2D2920] rounded-md border border-[#DDD8CC]"
          style={{ aspectRatio: "16 / 9" }}
        >
          <iframe
            src={VIDEO_URL}
            title="Video informativo Lauburu"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            loading="lazy"
            data-testid="youtube-iframe"
            className="absolute inset-0 w-full h-full"
          />
        </div>
      </div>
    </section>
  );
}
